import React, { useState } from "react";
const UpdateBanner = ({ onUpdate }) => {
    const [dismissed, setDismissed] = useState(false);
    const [updating, setUpdating] = useState(false);
    const timerRef = React.useRef(null);
    if (dismissed)
        return null;
    const handleDismiss = () => {
        // Dismiss for this session to avoid repeated prompts if update fails
        setDismissed(true);
    };
    const handleUpdateClick = () => {
        setUpdating(true);
        timerRef.current = window.setTimeout(() => {
            onUpdate();
        }, 1500);
    };
    React.useEffect(() => {
        return () => {
            if (timerRef.current !== null) {
                clearTimeout(timerRef.current);
            }
        };
    }, []);
    return (React.createElement("div", { className: "update-banner", role: "status" },
        React.createElement("span", { className: "update-banner-text" }, updating ? 'Updating to the latest version…' : 'A new version is available.'),
        updating && React.createElement("span", { className: "update-banner-spinner", "aria-hidden": "true" }),
        React.createElement("button", { className: "update-banner-btn", onClick: handleUpdateClick, disabled: updating }, updating ? 'Updating…' : 'Update now'),
        React.createElement("button", { className: "update-banner-close", onClick: handleDismiss, "aria-label": "Dismiss update notification", title: "Dismiss", disabled: updating }, "\u00D7")));
};
export default UpdateBanner;
